import Vue from 'vue'
import EditorCoreState, { DropPosition } from './state'

export { DropPosition }

export function initEditor(state: EditorCoreState): void {
  state.focus = {
    currentFocusId: '',
    nextFocusId: ''
  }
  state.dropState = {
    position: undefined,
    isVisible: false
  }
}

export function showDropPoint(state: EditorCoreState, position: DropPosition): void {
  Vue.set(state.dropState, 'position', {
    componentId: position.componentId,
    direction: position.direction
  })
  Vue.set(state.dropState, 'isVisible', true)
}

export function hideDropPoint(state: EditorCoreState): void {
  Vue.set(state.dropState, 'isVisible', false)
}

export function setDragEventType(state: EditorCoreState, eventType: string): void {
  Vue.set(state.dropState, 'eventType', eventType)
}

export function prepareFocusChange(state: EditorCoreState): void {
  state.focus.nextFocusId = ''
}

export function commitFocusChange(state: EditorCoreState): void {
  if (state.focus.currentFocusId !== state.focus.nextFocusId) {
    state.focus.currentFocusId = state.focus.nextFocusId
  }
  state.focus.nextFocusId = ''
}

export function requestFocus(state: EditorCoreState, componentId: string): void {
  state.focus.nextFocusId = componentId
}

export function clearFocus(state: EditorCoreState): void {
  state.focus.currentFocusId = ''
  state.focus.nextFocusId = ''
}

export function forceFocus(state: EditorCoreState, componentId: string): void {
  state.focus.currentFocusId = componentId
  state.focus.nextFocusId = ''
}

export default {
  initEditor,
  showDropPoint,
  hideDropPoint,
  setDragEventType,
  prepareFocusChange,
  commitFocusChange,
  requestFocus,
  clearFocus,
  forceFocus
}
